import { render } from "./StatisticsHoursByDayChart.vue?vue&type=template&id=98a88fa6"
import script from "./StatisticsHoursByDayChart.vue?vue&type=script&lang=js"
export * from "./StatisticsHoursByDayChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__